import React, { useEffect, useRef, useState } from "react";
import { Table, Form, Row, Col, Dropdown } from "react-bootstrap";
import { FiEdit2, FiTrash2, FiSearch } from "react-icons/fi";
import EditResignationModal from "../../components/modals/hrm/resignation/EditResignationModal";
import DeleteResignationModal from "../../components/modals/hrm/resignation/DeleteResignationModal";
import ResignationHeader from "../../components/hrm/ResignationHeader";
import { FiCalendar } from "react-icons/fi";


const initialData = [
  {
    name: "Anthony Lewis",
    dept: "Finance",
    reason: "Career Change",
    notice: "2024-01-14",
    resign: "2024-03-14",
    img: "/assets/img/users/user-32-1.jpg",
  },
  {
    name: "Brian Villalobos",
    dept: "Application Development",
    reason: "Entrepreneurial Pursuits",
    notice: "2024-01-21",
    resign: "2024-03-21",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    name: "Harvey Smith",
    dept: "Web Development",
    reason: "Relocation",
    notice: "2024-02-18",
    resign: "2024-04-18",
    img: "/assets/img/users/user-01-1.jpg",
  },
  {
    name: "Stephan Peralt",
    dept: "UI / UX",
    reason: "Health Reasons",
    notice: "2024-03-14",
    resign: "2024-04-14",
    img: "/assets/img/users/user-33-1.jpg",
  },
  {
    name: "Douglas Martini",
    dept: "Marketing",
    reason: "Personal Development",
    notice: "2024-04-10",
    resign: "2024-06-10",
    img: "/assets/img/users/user-34.jpg",
  },
  {
    name: "Jessica Moore",
    dept: "Human Resources",
    reason: "Higher Studies",
    notice: "2024-02-05",
    resign: "2024-04-05",
    img: "/assets/img/users/user-05.jpg",
  },
  {
    name: "Daniel Craig",
    dept: "Operations",
    reason: "Relocation",
    notice: "2024-01-30",
    resign: "2024-03-30",
    img: "/assets/img/users/user-06.jpg",
  },
  {
    name: "Sophia Turner",
    dept: "Finance",
    reason: "Family Reasons",
    notice: "2024-03-01",
    resign: "2024-05-01",
    img: "/assets/img/users/user-07.jpg",
  },
  {
    name: "Michael Scott",
    dept: "Sales",
    reason: "Better Opportunity",
    notice: "2024-02-12",
    resign: "2024-04-12",
    img: "/assets/img/users/user-08.jpg",
  },
  {
    name: "Rachel Green",
    dept: "Marketing",
    reason: "Career Change",
    notice: "2024-03-25",
    resign: "2024-05-25",
    img: "/assets/img/users/user-10.jpg",
  },
];
export default function ResignationPage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateRange, setDateRange] = useState("");
  const [filtered, setFiltered] = useState(initialData);

  const [editData, setEditData] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  // SEARCH
  const handleSearch = (value) => {
    setSearch(value);
    filterData(value, dateRange);
  };

const options = [
  "Today",
  "Yesterday",
  "Last 7 Days",
  "Last 30 Days",
  "This Year",
  "Next Year",
  "Custom Range",
];

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const ref = useRef();

  // close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  // DATE FILTER
  const handleDateFilter = (type) => {
    const today = new Date();
    let from;

    if (type === "Last 7 Days") {
      from = new Date();
      from.setDate(today.getDate() - 7);
    } else if (type === "Last 30 Days") {
      from = new Date();
      from.setDate(today.getDate() - 30);
    } else {
      setFiltered(data);
      return;
    }

    const result = data.filter(
      (item) => new Date(item.notice) >= from
    );

    setFiltered(result);
  };

  const filterData = (searchVal, dateVal) => {
    let result = data;

    if (searchVal) {
      result = result.filter((item) =>
        item.name.toLowerCase().includes(searchVal.toLowerCase())
      );
    }

    setFiltered(result);
  };


  
  return (
<div style={{ padding: "15px", background: "#f8f9fa",  }}  >
     <ResignationHeader/>
         <div className="card custom-card">
      {/* HEADER */}
      <div  style={{  background: "#ffffff",  }}  className="card-header d-flex justify-content-between flex-wrap">
        <h5>Resignation List</h5>

        <div className="d-flex gap-2 flex-wrap">
          {/* DATE */}
         <div className="date-wrapper" ref={ref}>
      {/* Input */}
      <div className="date-box" onClick={() => setOpen(!open)}>
        <FiCalendar />
        <input
          value="03/30/2026 - 04/05/2026"
          readOnly
        />
      </div>

      {/* Dropdown */}
      {open && (
        <div className="date-dropdown">
          {options.map((item, index) => (
            <div
              key={index}
              className={`date-item ${
                selected === item ? "active" : ""
              }`}
              onClick={() => {
                setSelected(item);
                setOpen(false);
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>

          {/* SORT */}
          <Dropdown>
            <Dropdown.Toggle className="text-dark border border-1 bg-white p-2">
              Sort By : Last 7 Days
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDateFilter("Last 7 Days")}>
                Last 7 Days
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDateFilter("Last 30 Days")}>
                Last 30 Days
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* FILTER ROW */}
      <div className="p-3 d-flex justify-content-between flex-wrap">
        <div>
          Row Per Page
          <Form.Select
            className="d-inline w-auto ms-2"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(e.target.value)}
          >
            <option>10</option>
            <option>25</option>
          </Form.Select>
        </div>

        <div className="search-box">
          <FiSearch />
          <input
            placeholder="Search"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <Table>
          <thead>
            <tr>
              <th></th>
              <th>Resigning Employee</th>
              <th>Department</th>
              <th>Reason</th>
              <th>Notice Date</th>
              <th>Resignation Date</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((item, i) => (
              <tr key={i}>
                <td><Form.Check /></td>

                <td className="d-flex align-items-center gap-2">
                  <img src={item.img} className="avatar" />
                  {item.name}
                </td>

                <td>{item.dept}</td>
                <td>{item.reason}</td>
                <td>{item.notice}</td>
                <td>{item.resign}</td>

                <td>
                  <FiEdit2
                    className="action-icon"
                    onClick={() => {
                      setEditData(item);
                      setShowEdit(true);
                    }}
                  />
                  <FiTrash2
                    className="action-icon ms-2"
                    onClick={() => setShowDelete(true)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* MODALS */}
      <EditResignationModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        data={editData}
      />

      <DeleteResignationModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
      />

      <style>
          {
               `
               .custom-card {
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.btn-white {
  background: #fff;
  border: 1px solid #e5e7eb;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.action-icon {
  cursor: pointer;
  color: #6b7280;
}

.action-icon:hover {
  color: #111;
}

.search-box {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  padding: 5px 10px;
  border-radius: 6px;
}

.search-box input {
  border: none;
  outline: none;
  margin-left: 5px;
}

.btn-orange {
  background: #f97316;
  border: none;
}

.btn-orange:hover {
  background: #ea580c;
}
  
/* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}

`
          }
      </style>
    </div>
</div>
  );
}